import { render, staticRenderFns } from "./RepeatCustomSubform.vue?vue&type=template&id=f4270424&scoped=true"
import script from "./RepeatCustomSubform.vue?vue&type=script&lang=js"
export * from "./RepeatCustomSubform.vue?vue&type=script&lang=js"
import style0 from "./RepeatCustomSubform.vue?vue&type=style&index=0&id=f4270424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4270424",
  null
  
)

export default component.exports